import React, { } from "react";

interface CardExchangeOptions {
  id: number;
  image: string;
  title: string;
  content: string | JSX.Element;
}

interface ExchangeOptionsProps {
  onlineExchange: CardExchangeOptions[];
  storeExchange: CardExchangeOptions[];
}


const ExchangeOptions: React.FC<ExchangeOptionsProps> = ({
  onlineExchange,
  storeExchange,
}) => {




  return (
    <div className="bg-[#efebe4]">
      <div>
        <h1 className="box-border text-center text-[#005D6E] block  text-[29px] font-semibold leading-[38.4px] pt-[25px]">
          It's easy to exchange
        </h1>
        
        
      </div>
      {/* <div>
        <div className="w-full rounded-lg md:rounded-full p-2 flex flex-col md:flex-row justify-center uppercase text-[14px] font-semibold text-[#75A7AD]">
          {sectionNames.map((name: ITabNames) => (
            <TabButton
              key={name}
              label={name.toUpperCase()}
              isActive={activeSection === name}
              onClick={() => {
                setActiveSection(name);
                setActiveTab(name === "In Store" ? "tab1" : "tab1");
              }}
            />
          ))}
        </div>
      </div> */}

     
    </div>
  );
};

export default ExchangeOptions;
